export default {
    authorsURL: `${process.env.REACT_APP_EDITION_DATA_URL}/annotations/authors.json`,
    authors: {},
    loaded: false
}	